/**
 * Comutatorul pasului de video din inscriere (U4).
 *
 * OPRIT implicit, si citit o singura data, aici: `VITE_*` se inline-uieste la
 * BUILD, deci valoarea nu se schimba la runtime — un `if` imprastiat prin
 * componente ar sugera altceva.
 *
 * Cat timp e oprit, ruta nu se inregistreaza deloc (vezi `routes-provider`), deci
 * nici intrarea din lista de cai permise a resolverului n-are ce sa deschida:
 * fara flag, zero comportament nou.
 *
 * ⚠️ `src/vite-env.d.ts` declara sase variabile, dar `ImportMetaEnv` are
 * `[key: string]: any` — deci un typo intr-un nume `VITE_*` compileaza si devine
 * `undefined` la runtime. De-aia numele e scris o SINGURA data, aici.
 */
/* 🔴 Scris EXACT asa, fara cast si fara acces indirect: Vite inlocuieste textual
   `import.meta.env.VITE_...` la build. Prima versiune era
   `(import.meta as {...}).env?.VITE_...` — TypeScript multumit, dar inlocuirea nu
   se mai potriveste, deci in bundle ramane `undefined` si flagul e mereu oprit.
   Simptomul a fost o ruta care nu se inregistra si un redirect tacut la
   autentificare; numele variabilei nici nu aparea in bundle. */
export const PAS_VIDEO_ACTIV =
    String(import.meta.env.VITE_PAS_VIDEO_INSCRIERE ?? '').toLowerCase() === 'true';
